import styled from 'styled-components';

export const Wrapper = styled.aside`
  width: 500px;
  padding: 20px;
`;